import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class HostMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: HostMetaModule,
            providers: [
                providePageMeta({
                    title: 'Tenants',
                    translationKey: 'page_tenants',
                    routerLink: '/host/tenants',
                    svgIcon: 'uipath:tenant',
                    type: 'Sidebar',
                    category: PageCategory.Host,
                    scope: PageScope.Global,
                    priority: 0,
                }),
                providePageMeta({
                    title: 'Tenants',
                    translationKey: 'page_tenants',
                    routerLink: '/',
                    svgIcon: 'uipath:tenant',
                    category: PageCategory.Host,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Tenants',
                    translationKey: 'page_tenants',
                    routerLink: '/host',
                    svgIcon: 'uipath:tenant',
                    category: PageCategory.Host,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Licenses',
                    translationKey: 'page_license',
                    routerLink: '/host/license',
                    svgIcon: 'uipath:license',
                    type: 'Sidebar',
                    category: PageCategory.Host,
                    scope: PageScope.Global,
                    priority: 1,
                }),
                providePageMeta({
                    title: 'Settings',
                    translationKey: 'page_settings',
                    routerLink: '/host/settings',
                    icon: 'settings',
                    type: 'Sidebar',
                    category: PageCategory.Host,
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
